import { useAppTranslation, useBackToShop } from "@/utils";
import { InfoCircleFilled } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

const PayOrderCancelled = () => {
  const { t } = useAppTranslation();

  const { backToShop, shopName } = useBackToShop();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center">
      <Flex vertical align="center" gap={"large"} className="tw:my-auto tw:w-full">
        <InfoCircleFilled width={80} className="tw:fill-color-warning" />

        <Flex vertical gap={"small"} align="center" className="tw:mt-1!">
          <Typography.Title level={5} className="tw:m-0! tw:text-center!">
            {t("pay.unAvailableContent")}
          </Typography.Title>
        </Flex>
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Button
          block
          onClick={() => {
            backToShop();
          }}
        >
          {shopName ? t("common.returnTo", { name: shopName }) : t("common.returnToShop")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PayOrderCancelled;
